export default "__VITE_ASSET__72792152__"